module.exports = __webpack_public_path__ + "assets/flags.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags.png
// module id = 1661
// module chunks = 7